define('modules/editor/views/editors/seo_custom_meta',['require','exports','module','base/collectionview','./seo_custom_meta_item','ldsh!../../templates/editors/seo_custom_meta'],function(require, exports, module){
  "use strict";
  var CollectionView = require("base/collectionview"),
      metaItemView = require("./seo_custom_meta_item");

  module.exports = CollectionView.extend({
    template: require("ldsh!../../templates/editors/seo_custom_meta"),
    itemContainer: ".js-meta-fields",
    itemView: metaItemView,
    events: {
      "click .js-add-meta-field": "addNewItem"
    },
    initialize: function() {
      this.listenTo(this.childVent, "item:remove", this.removeItem);
    },
    addNewItem: function(e){
      e.preventDefault();
      e.stopPropagation();
      this.collection.addItem();
    },
    removeItem: function(view){
      this.collection.remove(view.model);
    },
  });
});

